import request from '@/axios'

export const putFile = (data) => {
  return request({
    url: '/lebo-resource/oss/endpoint/put-file',
    method: 'post',
    data
  })
}

export const productList = (data) => {
  return request({
    url: '/lebo-trade/product/list',
    method: 'get',
    params: data
  })
}

export const submitProduct = (data) => {
  return request({
    url: '/lebo-trade/product/submit',
    method: 'post',
    data
  })
}

export const removeProduct = (data) => {
  return request({
    url: '/lebo-trade/product/remove',
    method: 'post',
    data
  })
}

export const submitExamine = (data) => {
  return request({
    url: '/lebo-trade/product/submit-examine',
    method: 'post',
    data
  })
}

export const updateExamine = (data) => {
  return request({
    url: '/lebo-trade/product/update-examine',
    method: 'post',
    data
  })
}

export const discountList = (data) => {
  return request({
    url: '/lebo-trade/productpromotion/list',
    method: 'get',
    params: data
  })
}

export const submitDiscount = (data) => {
  return request({
    url: '/lebo-trade/productpromotion/submit',
    method: 'post',
    data
  })
}

export const removeDiscount = (data) => {
  return request({
    url: '/lebo-trade/productpromotion/remove',
    method: 'post',
    data
  })
}

export const applyDiscountExamine = (data) => {
  return request({
    url: '/lebo-trade/productpromotion/apply-examine',
    method: 'post',
    data
  })
}

export const updateDiscountExamine = (data) => {
  return request({
    url: '/lebo-trade/productpromotion/submit-examine',
    method: 'post',
    data
  })
}

export const listProductType = () => {
  return request({
    url: '/lebo-trade/common/product-type/list',
    method: 'get'
  })
}

export const commonProductList = () => {
  return request({
    url: '/lebo-trade/common/product/list',
    method: 'get'
  })
}

export const appChannelList = () => {
  return request({
    url: '/lebo-trade/common/app-channel/list',
    method: 'get'
  })
}

export const reviewLog = (data) => {
  return request({
    url: '/lebo-desk/review-biz/list-examine',
    method: 'get',
    params: data
  })
}

export const orderList = (data) => {
  return request({
    url: '/lebo-trade/productorder/list',
    method: 'get',
    params: data
  })
}

export const applyForSupplement = (data) => {
  return request({
    url: '/lebo-trade/productorder/applyForSupplement',
    method: 'post',
    data
  })
}

export const applyForRefund = (data) => {
  return request({
    url: '/lebo-trade/productorder/applyForRefund',
    method: 'post',
    data
  })
}

export const supplementList = (data) => {
  return request({
    url: '/lebo-trade/productorder/list-supplement',
    method: 'get',
    params: data
  })
}

export const reviewForRefund = (data) => {
  return request({
    url: '/lebo-trade/productorder/reviewForRefund',
    method: 'post',
    data
  })
}

export const reviewForSupplement = (data) => {
  return request({
    url: '/lebo-trade/productorder/reviewForSupplement',
    method: 'post',
    data
  })
}

export const invoiceList = (data) => {
  return request({
    url: '/lebo-trade/invoice/list',
    method: 'get',
    params: data
  })
}

export const invoiceSubmit = (data) => {
  return request({
    url: '/lebo-trade/invoice/submit',
    method: 'post',
    data
  })
}

export const authList = (data) => {
  return request({
    url: '/lebo-device/receiverlicense/list',
    method: 'get',
    params: data
  })
}

export const authRecordList = (data) => {
  return request({
    url: '/lebo-device/oploglicense/list',
    method: 'get',
    params: data
  })
}
